<template>
  <div>
    <h2>Downloads</h2>
    <ul>
      <li><a href="/files/Setup-SynapBook.exe" target="_blank">Windows 10(x64)</a></li>
      <li><a href="https://play.google.com/store/apps/details?id=inertry.synapbook2" target="_blank">Android</a></li>
      <li>iOS(soon)</li>
      <li>Mac(soon)</li>
      <li>Linux(soon)</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'download-page'
}
</script>

<style lang="css" scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadPage.vue